exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hljs{\n  display: inline-block;\n  padding: 0;\n  background: transparent;\n  vertical-align:middle\n}\n.d2h-file-header{\n  display: none\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/lib/code-diff/index.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;CACtB;AACD;EACE,aAAa;CACd","file":"index.vue","sourcesContent":["\n.hljs{\n  display: inline-block;\n  padding: 0;\n  background: transparent;\n  vertical-align:middle\n}\n.d2h-file-header{\n  display: none\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ef528a6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/code-diff/index.vue
// module id = +eZN
// module chunks = 1